import { Center, Stack, Text, useMantineColorScheme } from "@mantine/core";
import { useTranslation } from "react-i18next";

import { AuctionsChart } from "../AuctionsChart";

import { TextSerif } from "@/components/elements";

import type { AuctionsChartPayload } from "@/types/auctions";

const HistoricalAuctionEmptyState = () => {
  const { t } = useTranslation();

  /* Theme */
  const { colorScheme } = useMantineColorScheme();
  const isDark = colorScheme === "dark";

  const placeholderChartData: AuctionsChartPayload[] = [
    { date: "2020-04-18", value: 38500, condition: "fair", result: "sold_post_auction" },
    { date: "2020-10-11", value: 44700, condition: "good", result: "sold_at_auction" },
    { date: "2021-01-24", value: 40100, condition: "fair", result: "not_sold" },
    { date: "2021-03-15", value: 42000, condition: "good", result: "sold" },
    { date: "2021-06-27", value: 33200, condition: "excellent", result: "sold_at_auction" },
    { date: "2021-09-22", value: 21500, condition: "excellent", result: "sold" },
    { date: "2022-02-13", value: 48900, condition: "good", result: "sold_post_auction" },
    { date: "2022-05-08", value: 16800, condition: "good", result: "sold" },
    { date: "2022-08-21", value: 27600, condition: "superb", result: "sold_at_auction" },
    { date: "2022-11-19", value: 10300, condition: "excellent", result: "sold" },
    { date: "2023-02-26", value: 75200, condition: "fair", result: "not_sold" },
    { date: "2023-06-03", value: 35700, condition: "superb", result: "sold" },
    { date: "2023-10-15", value: 63100, condition: "excellent", result: "sold_post_auction" },
    { date: "2024-02-17", value: 68200, condition: "excellent", result: "sold" },
    { date: "2024-07-06", value: 71900, condition: "superb", result: "sold_at_auction" },
    { date: "2024-11-23", value: 59800, condition: "good", result: "sold_post_auction" },
    { date: "2025-02-08", value: 74600, condition: "superb", result: "sold" },
    { date: "2025-05-17", value: 51200, condition: "project", result: "not_sold" },
    { date: "2025-08-30", value: 77500, condition: "excellent", result: "sold_at_auction" },
  ];

  return (
    <>
      <AuctionsChart
        carId="placeholder"
        data={placeholderChartData}
        hasSourceData={false}
        showOutliers={true}
        showReplicas={true}
        isEmptyState
        withTrendline={false}
        hideTitle // avoid showing the title when it is already visible elsewhere
      />

      <Center pos="absolute" top={0} right={0} left={0} bottom={30} style={{ zIndex: 1 }}>
        <Stack gap="md" ta="center">
          <Stack gap="sm">
            <Text fz="h3">{t("components.AuctionAnalysis.title")}</Text>
            <TextSerif fz="sm" c={isDark ? "#999999" : "#6A6A84"}>
              {t("car.no_data_available")}
            </TextSerif>
          </Stack>
        </Stack>
      </Center>
    </>
  );
};

export default HistoricalAuctionEmptyState;
